import React from 'react';
import { GiftIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { bonuses } from '../data/bonuses';
export function BonusesSection() {
  return <section aria-labelledby="bonuses-title" className="bg-white px-5 py-20 md:py-28" data-id="element-21" data-mp="gxzvn96yz5t4">
      <Reveal className="mx-auto max-w-4xl" data-id="element-22" data-mp="vqtbivq5lnyb">
        <div className="text-center" data-id="element-23" data-mp="qt9whtlmt75b">
          <p className="text-[11px] font-bold uppercase tracking-[0.18em] text-amber" data-id="element-24" data-mp="qs8ef5677ke3">
            INCLUDED FREE, NOT SOLD SEPARATELY
          </p>
          <h2 id="bonuses-title" className="mt-4 flex items-center justify-center gap-3 text-3xl font-extrabold tracking-tight text-pine md:text-4xl" data-id="element-25" data-mp="zurfbjqfbmxp">
            <GiftIcon className="h-7 w-7 shrink-0 text-turquoise" strokeWidth={2} aria-hidden="true" data-id="element-26" data-mp="19katic36ysm8" />5 Exclusive
            Bonuses
          </h2>
          <p className="mt-4 text-slate-body" data-id="element-27" data-mp="1nkvhdmnyreml">Total value $124 — included free at today&apos;s price.</p>
        </div>
        <div className="mt-12 space-y-4" data-id="element-28" data-mp="1jkbhibc09wwr">
          {bonuses.map(({
          image,
          alt,
          title,
          description,
          price
        }, index) => <article key={title} className="flex items-center gap-4 rounded-card border border-slate-line bg-white p-4 shadow-card sm:gap-5" data-id="element-29" data-mp="3psoe7xpkrnie" data-mpi={index}>
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-pine font-display text-sm font-bold text-white" data-id="element-30" data-mp="2np5ieutpm2y">
                {index + 1}
              </span>
              <img src={image} alt={alt} loading="lazy" className="aspect-[3/4] w-16 shrink-0 rounded-[10px] object-cover shadow-card sm:w-20" data-id="element-31" data-mp="chpguygp7nk4" />
              <div className="min-w-0 flex-1" data-id="element-32" data-mp="qb6yuetqks81">
                <h3 className="text-sm font-bold leading-snug text-pine md:text-base" data-id="element-33" data-mp="q9vlpoeei849">{title}</h3>
                <p className="mt-1.5 text-xs leading-relaxed text-slate-body md:text-sm" data-id="element-34" data-mp="vbkx555jcnsv">{description}</p>
              </div>
              <p className="flex shrink-0 flex-col items-end gap-0.5 text-right" data-id="element-35" data-mp="109mjbyy9d38k">
                <span className="text-xs font-medium text-slate-body line-through" data-id="element-36" data-mp="alqrgidozhxb">{price}</span>
                <span className="font-display text-sm font-extrabold uppercase tracking-wide text-turquoise" data-id="element-37" data-mp="5np9y1vwzqny">
                  FREE
                </span>
              </p>
            </article>)}
        </div>
      </Reveal>
    </section>;
}